import { useEffect, useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import { Box, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { ExtraDataMatch } from "../../services/shirts/types";
import { Dictionary } from "../../types/types";

interface MatchPropertyFormProps {
  setExtraData: Function;
  data?: ExtraDataMatch;
  errors?: Dictionary<boolean>;
}

const MatchPropertyForm = ({
  data,
  setExtraData,
  errors,
}: MatchPropertyFormProps) => {
  const [date, setDate] = useState<Dayjs | null>(null);
  const [home, setHome] = useState<string | undefined>(undefined);
  const [away, setAway] = useState<string | undefined>(undefined);
  const [resultH, setResultH] = useState<number | undefined>(undefined);
  const [resultA, setResultA] = useState<number | undefined>(undefined);

  const tfMainStyle = {
    "& .MuiOutlinedInput-notchedOutline": {
      borderWidth: "0px",
    },
  };

  const tfLabelProps = {
    sx: {
      color: "#6f7d95",
      fontSize: "1rem",
      fontWeight: 500,
      "& .MuiOutlinedInput-notchedOutline": {
        fontSize: "28px",
        border: "0px !important",
      },
    },
  };

  const tfInputProps = {
    disableUnderline: true,
    sx: {
      backgroundColor: "#f4f6f9",
      borderRadius: "3px",
      color: "#6f7d95",
      fontSize: "1rem",
      fontWeight: 500,
    },
  };

  useEffect(() => {
    if (data) {
      if (data.match?.date) {
        setDate(dayjs(data.match.date));
      }
      setHome(data.match?.home);
      setAway(data.match?.away);
      setResultH(data.match?.resultH);
      setResultA(data.match?.resultA);
    }
  }, [data]);

  useEffect(() => {
    let tempData: ExtraDataMatch = {
      match: {
        away: away,
        date: date?.format("YYYY/MM/DD"),
        home: home,
        resultH: resultH,
        resultA: resultA,
      },
    };
    setExtraData(tempData);
  }, [date, home, away, resultH, resultA]);

  return (
    <Box>
      <Box sx={{ marginTop: "1rem" }}>
        <DatePicker
          format="DD/MM/YYYY"
          label={"Date"}
          onChange={(newValue) => setDate(newValue)}
          value={date}
          slotProps={{
            textField: {
              fullWidth: true,
              sx: tfMainStyle,
              InputProps: tfInputProps,
              InputLabelProps: tfLabelProps,
              error: errors ? errors["worn_date"] : false,
            },
          }}
        />
      </Box>

      <Box sx={{ marginTop: "1rem" }}>
        <TextField
          fullWidth
          sx={tfMainStyle}
          InputLabelProps={tfLabelProps}
          InputProps={tfInputProps}
          label="Home Team"
          variant="outlined"
          value={home ?? ""}
          onChange={(e) => setHome(e.target.value)}
        />
      </Box>

      <Box sx={{ marginTop: "1rem" }}>
        <TextField
          fullWidth
          sx={tfMainStyle}
          InputLabelProps={tfLabelProps}
          InputProps={tfInputProps}
          label="Away Team"
          variant="outlined"
          value={away ?? ""}
          onChange={(e) => setAway(e.target.value)}
        />
      </Box>

      <Box sx={{ marginTop: "1rem" }}>
        <TextField
          fullWidth
          label="Home Score"
          variant="outlined"
          value={resultH ?? 0}
          sx={tfMainStyle}
          InputLabelProps={tfLabelProps}
          InputProps={tfInputProps}
          onChange={(e) => setResultH(Number(e.target.value))}
        />
      </Box>

      <Box sx={{ marginY: "1rem" }}>
        <TextField
          sx={tfMainStyle}
          InputLabelProps={tfLabelProps}
          InputProps={tfInputProps}
          fullWidth
          label="Away Score"
          variant="outlined"
          value={resultA ?? 0}
          onChange={(e) => setResultA(Number(e.target.value))}
        />
      </Box>
    </Box>
  );
};

export default MatchPropertyForm;
